import addAlpha from "src/theme/functions/addAlpha";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  menu: {
    ".css-jvingl-MuiPaper-root-MuiPopover-paper-MuiMenu-paper": {
      marginTop: "-40px !important",
    },
  },
  paper: {
    width: 330,
    height: 450,
    overflow: "visible",
    overflowY: "auto",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
  avatar: {
    height: "50px !important",
    width: "50px!important",
  },
  text: { overflowWrap: "break-word", wordWrap: "break-word", fontSize: 12 },
  upgradeNow: {
    marginTop: 1,
    backgroundColor: "#FF8A00",
    textTransform: "capitalize",
  },
  upgrade: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  upgradeBox: {
    backgroundColor: addAlpha("#FF8A00", 0.1),
    width: "100%",
  },
  icon: {
    height: 17,
    width: 17,
  },
  button: {
    height: "100%",
    width: "100%",
    borderRadius: 15,
  },
  marginLeft: {
    marginLeft: 10,
  },
  paddingTop: {
    paddingTop: "10px",
  },
  //   menuItem: {
  //     cursor: "arrow",
  //     "&:hover": {
  //       backgroundColor: "transparent",
  //       cursor: "arrow",
  //     },
  //   },
  menuItem: {
    cursor: "arrow",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
      cursor: "arrow",
    },
  },
  logout: {
    color: "red",
    marginTop: 20,
    backgroundColor: theme.palette.primary.light,
  },
  box: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  menuItemHeight: {
    height: 40,
  },
  formControl: {
    display: "block",
  },
  profile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    // position: "relative",
    color: theme.palette.text.secondary,
    // flex: 1,
    marginLeft: 40,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 10,
    },
  },
  boxChip: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 10,
  },
  profileName: {
    fontFamily: "poppins",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "24px",
    marginTop: "5px",
    color: "#272525",
    width: "100%",
    height: "20px",
    display: "flex",
    justifyContent: "center",
  },
  profilePseudonym: {
    fontFamily: "poppins",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#777777",
    width: "100%",
    height: "18px",
    display: "flex",
    justifyContent: "center",
  },
  chip: {
    height: 20,
    borderRadius: 0,
    fontSize: "9px",
    whiteSpace: "normal",
    color: "#0085FF",
    backgroundColor: addAlpha("#0085FF", 0.1),
    display: "flex",
    justifyContent: "center",
  },
  progress: {
    margin: "auto",
    display: "block",
    marginTop: 2,
    fontWeight: "400",
    color: "#4d1277",
  },
  type: {
    fontSize: "13px",
    fontWeight: 500,
    fontFamily: "Poppins",
    color: "#000",
  },
}));
export default useStyles;
